import { render, staticRenderFns } from "./PopoverTagsList.vue?vue&type=template&id=242e8d5c&scoped=true&"
import script from "./PopoverTagsList.vue?vue&type=script&lang=js&"
export * from "./PopoverTagsList.vue?vue&type=script&lang=js&"
import style0 from "./PopoverTagsList.vue?vue&type=style&index=0&id=242e8d5c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e8d5c",
  null
  
)

export default component.exports